import React, { useState, useEffect } from 'react';
import axios from "axios";
import Header from '../Header';
import Footer from '../Footer';
import 'datatables.net-bs5/css/dataTables.bootstrap5.min.css';
import $ from 'jquery';
import 'datatables.net-bs5';
import { Link } from 'react-router-dom';
import { format } from 'date-fns';
import CommonDatePicker from '../datepicker/CommonDatePicker';
import 'datatables.net';
import { API_URL, BASE_URL } from '../Config';
import config from "../common/Config";
import * as XLSX from 'xlsx';
import Select from 'react-select';

const CrossOffReport = () => {
	const [draw, setDraw] = useState(1);
	const [start, setStart] = useState(0);
	const [length, setLength] = useState(50);
	const now = new Date();
	const startOfMonth = new Date(now.getFullYear(), now.getMonth(), 1);
	const endOfMonth = new Date(now.getFullYear(), now.getMonth() + 1, 0);
	const [dates, setDates] = useState([startOfMonth, endOfMonth]);
	const [reportrange, setReportrange] = useState('');
	const [reportAmount, setReportAmount] = useState('');
	//const [pageOption, setPageOption] = useState('');
	const [pageCndDataOptions, setPageCndDataOptions] = useState([]);
	const [pageCndData, setPageCndData] = useState('');
	const [showProductWise, setShowProductWise] = useState(false);
	const [productWiseOptions, setProductWiseOptions] = useState([]);
	const [productWise, setProductWise] = useState('');
	const [productReport, setProductReport] = useState([]);
	const [showpickListOption, setShowpickListOption] = useState(false);
	const [pickListOptions, setPickListOptions] = useState([]);
	const [pickListWise, setPickListWise] = useState('');
	const [showSalesRepOption, setShowSalesRepOption] = useState(false);
	const [salesRepOptions, setSalesRepOptions] = useState([]);
	const [salesRepWise, setSalesRepWise] = useState('');
	const accessToken = localStorage.getItem('accessToken');
	// --- NEW: for react-select search ---
	const [productInputValue, setProductInputValue] = useState('');
	const [productFilteredOptions, setProductFilteredOptions] = useState([]);
	const [productValue, setProductValue] = useState(null);
	// ... existing handlers ...
	const handleDateChange = (value) => {
		setDates(value);
		let startDate = format(value[0], 'dd-MM-yyyy');
		let endDate = format(value[1], 'dd-MM-yyyy');
		setReportrange(startDate + ' - ' + endDate);
	};
	const handleChangeOption = (event) => {
		const value = event.target.value;
		setPageCndData(value);
	};
	// --- NEW: productHandleInputChange and productHandleChange ---
	const productHandleInputChange = (inputValue) => {
		setProductInputValue(inputValue);
		const newFilteredOptions = productWiseOptions.filter(option =>
			option.label.toLowerCase().includes(inputValue.toLowerCase()) ||
			(option.code && option.code.toLowerCase().includes(inputValue.toLowerCase()))
		);
		setProductFilteredOptions(newFilteredOptions);
	};
	const productHandleChange = (selectedOption) => {
		if (selectedOption) {
			setProductValue(selectedOption);
			setProductWise(selectedOption.value);
		} else {
			setProductValue(null);
			setProductWise('');
		}
	};
	// --- END NEW ---
	const handleChangePickOption = (event) => {
		const value = event.target.value;
		setPickListWise(value);
	};

	const handleChangeSRapOption = (event) => {
		const value = event.target.value;
		setSalesRepWise(value);
	};

	const searchFormData = () => {
		// let startDate = format(dates[0], 'dd-MM-yyyy');
		// let endDate = format(dates[1], 'dd-MM-yyyy');
		// setReportrange(startDate + ' - ' + endDate);
		fetchProductWiseData();
	};

	useEffect(() => {
		if (reportrange) {
			fetchProductWiseData();
			fetchProductOptions();
		}
	}, [reportrange]);

	const fetchProductOptions = async () => {
		let startDate = format(dates[0], 'MM/dd/yyyy');
		let endDate = format(dates[1], 'MM/dd/yyyy');
		let pdtrange = startDate + ' - ' + endDate;
		const pdtData = new FormData();
		pdtData.append('reportrange', pdtrange);

		const apiPdtOptionUrl = `${config.API_URL}/getproduct_for_report`;
		try {
			const response = await fetch(apiPdtOptionUrl, {
				method: 'POST',
				headers: {
					authorization: `Bearer ${accessToken}`,
				},
				body: pdtData,
			});
			const data = await response.json();
			const formattedOptions = data.product.map(item => ({
				label: `${item.name}`,
				value: item.id,
				name: item.name
			}));
			setProductWiseOptions(formattedOptions);
		} catch (error) {
			console.error('api fail Error fetching Not Order Report:', error);
		}
	};

	const fetchPickListOptions = async () => {
		let startDate = format(dates[0], 'MM/dd/yyyy');
		let endDate = format(dates[1], 'MM/dd/yyyy');
		let pdtrange = startDate + ' - ' + endDate;
		const pdtData = new FormData();
		pdtData.append('reportrange', pdtrange);

		const apiPickListUrl = `${config.API_URL}/getpicklist`;
		try {
			const response = await fetch(apiPickListUrl, {
				method: 'POST',
				headers: {
					// 'Content-Type': 'application/json',
					authorization: `Bearer ${accessToken}`,
				},
				body: pdtData,
			});

			const data = await response.json();
			const formattedOptions = data.picklist.map(item => ({
				key: `${item.picklist_number}`,
				value: item.picklist_number,
			}));
			setPickListOptions(formattedOptions);
		} catch (error) {
			console.error('api fail Error fetching Not Order Report:', error);
		}
	};

	const fetchSalesRepOptions = async () => {
		let startDate = format(dates[0], 'MM/dd/yyyy');
		let endDate = format(dates[1], 'MM/dd/yyyy');
		let pdtrange = startDate + ' - ' + endDate;
		const pdtData = new FormData();
		pdtData.append('reportrange', pdtrange);

		//const apiPickListUrl = `${config.API_URL}/getpicklist`;
		const apiPickListUrl = `${config.API_URL}/getSalesRep`;
		try {
			const response = await fetch(apiPickListUrl, {
				method: 'POST',
				headers: {
					// 'Content-Type': 'application/json',
					authorization: `Bearer ${accessToken}`,
				},
				body: pdtData,
			});

			const data = await response.json();
			const formattedOptions = data.data.map(item => ({
				key: `${item.first_name} ${item.last_name}`,
				value: item.id,
			}));
			setSalesRepOptions(formattedOptions);
		} catch (error) {
			console.error('api fail Error fetching Not Order Report:', error);
		}
	};

	const fetchProductWiseData = async () => {
		// let startDate = format(dates[0], 'MM-dd-yyyy');
		// let endDate = format(dates[1], 'MM-dd-yyyy');
		// let pdtrange = startDate + ' - ' + endDate;
		const pdtData = new FormData();
		let ptype = pageCndData;

		// alert(ptype);
		if (ptype === 'order_wise') {
			setProductWise('');
			setPickListWise('');
			setSalesRepWise('');
		}
		else if (ptype === 'pick_list_wise') {
			setProductWise('');
			setSalesRepWise('');
		}
		else if (ptype === 'sales_rep_wise') {
			setPickListWise('');
			setProductWise('');
		}

		// console.log(ptype);
		pdtData.append('draw', draw);
		pdtData.append('start', start);
		pdtData.append('length', length);
		pdtData.append('reportrange', reportrange);
		pdtData.append('type', ptype ? ptype : 'product_wise');
		pdtData.append('product_id', productWise);
		pdtData.append('pick_list', pickListWise);
		pdtData.append('sales_rep_id', salesRepWise);

		const apiMissingProductUrl = `${config.API_URL}/get_missing_order_report`;

		try {
			const response = await fetch(apiMissingProductUrl, {
				method: 'POST',
				headers: {
					// 'Content-Type': 'application/json',
					authorization: `Bearer ${accessToken}`,
				},
				body: pdtData,
			});

			if (!response.ok) {
				throw new Error('Failed to fetch Not Order Report');
			}
			const data = await response.json();
			data.type = ptype ? ptype : 'product_wise';
			console.log(data);
			setProductReport(data);
			setReportAmount(data.order_total + ' | Missing Amt : ' + data.missing_total);
		} catch (error) {
			console.error('api fail Error fetching Not Order Report:', error);
		}
	};

	useEffect(() => {
		if (accessToken === null) {
			window.location.href = `${config.BASE_URL}/login`;
			return;
		}
		const options = [
			{ value: 'product_wise', key: 'Product Wise' },
			{ value: 'order_wise', key: 'Order Wise' },
			{ value: 'pick_list_wise', key: 'Pick List Wise' },
			{ value: 'sales_rep_wise', key: 'Sales Rep Wise' },
		];

		setPageCndDataOptions(options);
		fetchProductOptions();
		fetchProductWiseData();
		fetchPickListOptions();
		fetchSalesRepOptions();
	}, []);


	useEffect(() => {
		if (pageCndData) {
			fetchProductWiseData();
		}
	}, [pageCndData]);

	useEffect(() => {
		setProductFilteredOptions(productWiseOptions);
	}, [productWiseOptions]);


	const getColumnsForType = (type) => {
		switch (type) {
			case 'product_wise':
				return [
					{ data: null },
					{ data: 'product_name' },
					{ data: 'order_type' },
					{ data: 'total_items' },
					{ data: 'missing_total' }
				];
			case 'order_wise':
				return [
					{ data: null },
					{ data: 'date' },
					{ data: 'reference_no' },
					{ data: 'customer' },
					{
						data: null,
						render: function (data, type, row) {
							return `<span>${parseFloat(row.order_total).toFixed(2)}</span>`;
						}
					},
					{ data: 'missing_total' },
					{ data: 'return_total' },
					{ data: 'deliverd_total' },
					{ data: 'return_total' },
					{ data: 'sale_status' }
				];
			case 'pick_list_wise':
				return [
					{ data: null },
					{ data: 'date' },
					{ data: 'reference_no' },
					{ data: 'customer' },
					{
						data: null,
						render: function (data, type, row) {
							return `<span>${parseFloat(row.order_total).toFixed(2)}</span>`;
						}
					},
					{ data: 'missing_total' },
					{ data: 'return_total' },
					{ data: 'deliverd_total' },
					{ data: 'return_total' },
					{ data: 'sale_status' }
				];
			case 'sales_rep_wise':
				return [
					{ data: null },
					{ data: 'date' },
					{ data: 'reference_no' },
					{ data: 'customer' },
					{
						data: null,
						render: function (data, type, row) {
							return `<span>${parseFloat(row.order_total).toFixed(2)}</span>`;
						}
					},
					{ data: 'missing_total' },
					{ data: 'return_total' },
					{ data: 'deliverd_total' },
					{ data: 'return_total' },
					{ data: 'sale_status' }
				];
			default:
				return [];
		}
	};

	useEffect(() => {

		const clearTable = () => {
			if ($.fn.DataTable.isDataTable('#CrossReport')) {
				$('#CrossReport').DataTable().destroy();
				$('#CrossReport').empty(); // Clear existing data and headers
			}
		};

		const initializeDataTable = () => {
			const columns = getColumnsForType(productReport.type);
			const headers = getHeadersForType(productReport.type);
			clearTable();

			const table = $('#CrossReport').DataTable({
				pageLength: 50,
				paging: true,
				lengthMenu: [10, 20, 50],
				searching: true,
				ordering: true,
				info: true,
				responsive: true,
				autoWidth: false,
				language: {
					paginate: {
						first: 'First',
						last: 'Last',
						next: 'Next',
						previous: 'Previous',
					},
					search: 'Search:',
				},
				data: productReport.data,
				columns: columns,
				drawCallback: function (settings) {
					var api = this.api();
					var startIndex = api.page.info().start;
					api.column(0, { page: 'current' }).nodes().each(function (cell, i) {
						cell.innerHTML = startIndex + i + 1;
					});
				}
			});

			// Update the table header
			$('#CrossReport thead').html(headers.join(''));
		};

		if (productReport.type === "product_wise" || productReport.type === "order_wise" || productReport.type === "pick_list_wise" || productReport.type === "sales_rep_wise") {
			initializeDataTable();
		}

		// Cleanup DataTable on component unmount or when `productReport` changes
		return () => {
			clearTable();
		};
	}, [productReport]);


	const getHeadersForType = (type) => {
		switch (type) {
			case 'product_wise':
				return ["<tr>",
					"<th>#</th>",
					"<th>Product (Code)</th>",
					"<th>Order Type</th>",
					"<th>Qty</th>",
					"<th>Missing Amt</th>",
					"</tr>"
				];
			case 'order_wise':
				return ["<tr>",
					"<th>#</th>",
					"<th>Order Date</th>",
					"<th>Order Id</th>",
					"<th>Customers (A/c No)</th>",
					"<th>Order Amt</th>",
					"<th>Missing Qty</th>",
					"<th>Missing Amt</th>",
					"<th>Delivered Amt</th>",
					"<th>Return Amt</th>",
					"<th>Status</th>",
					"</tr>"
				];
			case 'pick_list_wise':
				return ["<tr>",
					"<th>#</th>",
					"<th>Order Date</th>",
					"<th>Order Id</th>",
					"<th>Customers (A/c No)</th>",
					"<th>Order Amt</th>",
					"<th>Missing Qty</th>",
					"<th>Missing Amt</th>",
					"<th>Delivered Amt</th>",
					"<th>Return Amt</th>",
					"<th>Status</th>",
					"</tr>"
				];
			case 'sales_rep_wise':
				return ["<tr>",
					"<th>#</th>",
					"<th>Order Date</th>",
					"<th>Order Id</th>",
					"<th>Customers (A/c No)</th>",
					"<th>Order Amt</th>",
					"<th>Missing Qty</th>",
					"<th>Missing Amt</th>",
					"<th>Delivered Amt</th>",
					"<th>Return Amt</th>",
					"<th>Status</th>",
					"</tr>"
				];
			default:
				return [];
		}
	};

	/*useEffect(() => {
		if (productReport.type == "product_wise") {
			setShowProductWise(true);
		} else {
			setShowProductWise(false);
		}

		if (productReport.type == "pick_list_wise") {
			setShowpickListOption(true);
		} else {
			setShowpickListOption(false);
		}

		if (productReport.type == "sales_rep_wise") {
			setShowSalesRepOption(true);
			console.log("show sales_rep_wise");
		} else {
			setShowSalesRepOption(false);
		}
		console.log(productReport.type);
	}, [productReport.type]);*/

	useEffect(() => {
		setShowProductWise(false);
		setShowpickListOption(false);
		setShowSalesRepOption(false);

		switch (pageCndData) {
			case "product_wise":
				setShowProductWise(true);
				break;
			case "pick_list_wise":
				setShowpickListOption(true);
				break;
			case "sales_rep_wise":
				setShowSalesRepOption(true);
				console.log("show sales_rep_wise");
				break;
			default:
				break;
		}
		if (pageCndData == "") {
			setShowProductWise(true);
		}

		// console.log(pageCndData);
	}, [pageCndData]);


	const handleDownloadExcel = () => {
		// Get table element
		const table = document.getElementById('CrossReport');
		// Convert table to worksheet
		const wb = XLSX.utils.table_to_book(table, { sheet: "Sheet1" });
		// Export to file
		XLSX.writeFile(wb, 'CrossOffReport.xlsx');
	};

	return (
		<div>
			<Header />
			<div className="breadcrumbs">
				<div className="container-fluid">
					<div className="row">
						<div className="col-12 col-lg-12 col-sm-12">
							<Link to="/Dashboard"><i className="fa fa-home"></i></Link>
							<Link to="/reports/missing_order">Reports</Link>
							<Link to="/reports/missing_order">Cross off report</Link>
						</div>
					</div>
				</div>
			</div>
			<div className="main-container">
				<div className="container-fluid">
					<div className="row">


						<div className="date-range-picker col-md-3 col-lg-3 col-sm-12" style={{ float: 'left' }}>
							<div class="row mb-3 padd-0">
								<label class="col-sm-4" style={{ marginBottom: '5px' }} ><b>Select Date</b></label>
								<div class="col-sm-8">
									<CommonDatePicker
										value={dates}
										onChange={handleDateChange}
										// placeholder="DD/MM/YYYY - DD/MM/YYYY"
										style={{ width: '100%' }}
									/>
								</div>
							</div>
						</div>

						<div className="date-range-picker col-md-3 col-lg-3 col-sm-12" style={{ float: 'left' }}>
							<div class="row mb-3 padd-0">
								<label class="col-sm-4" style={{ marginBottom: '5px' }} ><b>Product Wise</b></label>
								<div class="col-sm-8">
									<select value={pageCndData} onChange={handleChangeOption} className="form-control selectinput" name="" id="" >
										{pageCndDataOptions.map(option => (
											<option key={option.value} value={option.value}>
												{option.key}
											</option>
										))}
									</select>
								</div>
							</div>
						</div>

						{showProductWise && (
							<div className="date-range-picker col-md-3 col-lg-3 col-sm-12" style={{ float: 'left' }}>
								<div class="row mb-3 padd-0">
									<label class="col-sm-4" style={{ marginBottom: '5px' }} ><b>Select Product</b></label>
									<div class="col-sm-8">
										<Select
											className='abovedd'
											isClearable
											onInputChange={productHandleInputChange}
											onChange={productHandleChange}
											options={productFilteredOptions}
											placeholder="Select Product"
											value={productValue}
											styles={{marginBottom: '15px'}}
										/>
									</div>
								</div>
							</div>
						)}


						{showpickListOption && (
							<div className="date-range-picker col-md-3 col-lg-3 col-sm-12" style={{ float: 'left' }}>
								<div class="row mb-3 padd-0">
									<label class="col-sm-4" style={{ marginBottom: '5px' }} ><b>&nbsp;</b></label>
									<div class="col-sm-8">
										<select value={pickListWise} onChange={handleChangePickOption} className="form-control selectinput" name="" id="" >
											<option value="">Select Pick List</option>
											{pickListOptions.map(option => (
												<option key={option.value} value={option.value}>
													{option.key}
												</option>
											))}
										</select>
									</div>
								</div>
							</div>
						)}

						{showSalesRepOption && (
							<div className="date-range-picker col-md-3 col-lg-3 col-sm-12" style={{ float: 'left' }}>
								<div class="row mb-3 padd-0">
									<label class="col-sm-4" style={{ marginBottom: '5px' }} ><b>&nbsp;</b></label>
									<div class="col-sm-8">
										<select value={salesRepWise} onChange={handleChangeSRapOption} className="form-control selectinput" name="" id="" >
											<option value="">Select Sales Rap</option>
											{salesRepOptions.map(option => (
												<option key={option.value} value={option.value}>
													{option.key}
												</option>
											))}
										</select>
									</div>
								</div>
							</div>
						)}


						<div className="col-md-2 col-lg-2 col-sm-4" style={{ float: 'left' }} >
							<button type="button" onClick={searchFormData} className="acceptbtn" style={{ float: 'left' }}>Submit</button>
						</div>
						<div className="col-md-1 col-lg-1 col-sm-2" style={{ float: 'left' }}>
							<button className="acceptbtn" onClick={handleDownloadExcel} style={{ float: 'left' }}>
								Export
							</button>
						</div>
					</div>
					<div className="total-manifests-area dashboard">
						<p className="text-center" style={{ border: 'none', padding: '0px 0 15px 0', margin: '0px 0 15px 0', borderBottom: '1px solid #d0cece' }} ><b>Order Amt : {reportAmount} </b></p>
						<div className="verical-scrl-wrapper common-table autoheight-table crossofreport" id="style-3">
							
							<table className="table table-bordered resizable" id="CrossReport">
								<thead>
								</thead>
								<tbody>
								</tbody>
							</table>
						</div>
					</div>
				</div>
			</div>
			<Footer />
		</div>
	);
}

export default CrossOffReport;